
const links = {
	participations: (lang: string, year: string) => `${lang}/editions/${year}/invites`,
	participation: (lang: string, year: string, slug: string) => `${links.participations(lang, year)}/${slug}`,
	events: (lang: string, year: string) => `${lang}/editions/${year}/evenements`,
	event: (lang: string, year: string, slug: string) => `${links.events(lang, year)}/${slug}`,
	places: (lang: string, year: string) => `${lang}/editions/${year}/espaces`,
	place: (lang: string, year: string, slug: string) => `${links.places(lang, year)}/${slug}`,
	stands: (lang: string, year: string) => `${lang}/editions/${year}/exposants`,
	stand: (lang: string, year: string, standId: id) => `${links.stands(lang, year)}/${standId}`,
};

export default links;
